
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topics/[...param]",
      function () {
        return require("private-next-pages/topics/[...param].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topics/[...param]"])
      });
    }
  